import { Box, Stepper, Step, StepLabel, Typography, styled } from "@mui/material";
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { useMatch, useNavigate, useParams } from "react-router-dom";

// Custom connector to make the line thinner and gray
const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#004A99', // Matches your primary blue
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#004A99',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#eaeaf0',
    borderTopWidth: 2,
    borderRadius: 1,
  },
}));

const steps = [
  { label: "Details", path: "details" },
  { label: "Ownership", path: "ownership" },
  { label: "Investment", path: "investment" },
];

export default function EditCompanyHeader() {
  const navigate = useNavigate();
  const { companyId } = useParams();

  const isOwnership = useMatch("/company/:companyId/edit/ownership");
  const isInvestment = useMatch("/company/:companyId/edit/investment");

  let activeStep = 0;
  if (isOwnership) activeStep = 1;
  if (isInvestment) activeStep = 2;

  return (
    <Box sx={{ width: "100%", maxWidth: "800px", margin: "0 auto", mb: 6, mt: 2 }}>
      <Stepper 
        activeStep={activeStep} 
        connector={<QontoConnector />}
        alternativeLabel // This puts labels under the icons for a cleaner look
      >
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel
              onClick={() => navigate(`/company/${companyId}/edit/${step.path}`)}
              StepIconProps={{
                sx: {
                  cursor: "pointer",
                  // Style the circle icons
                  '&.Mui-active': { color: '#004A99' },
                  '&.Mui-completed': { color: '#004A99' },
                }
              }}
              sx={{
                cursor: "pointer",
                '& .MuiStepLabel-label': {
                  mt: 1,
                  fontSize: '0.875rem',
                  fontWeight: activeStep === index ? 600 : 400,
                  color: activeStep === index ? '#004A99' : 'text.secondary',
                },
              }}
            >
              {step.label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}